import DOMPurify from 'dompurify'; // استيراد DOMPurify لتنظيف النص
const containsHTML = (text) => {
    return /<[a-z][\s\S]*>/i.test(text);
  };

  // دالة لقص النص مع الحفاظ على علامات HTML إذا كانت موجودة
  const truncateText = (text, wordLimit) => {
    if (containsHTML(text)) {
      // إذا كان النص يحتوي على HTML، نقوم بقص النص مع الحفاظ على العلامات
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = text;
      let words = tempDiv.textContent.split(' ');
      if (words.length > wordLimit) {
        words = words.slice(0, wordLimit);
        tempDiv.textContent = words.join(' ') + '...';
      }
      return tempDiv.innerHTML;
    } else {
      // إذا كان النص عاديًا، نقوم بقص النص بشكل عادي
      const words = text.split(' ');
      if (words.length > wordLimit) {
        return words.slice(0, wordLimit).join(' ') + '...';
      }
      return text;
    }
  };
  
  // تنظيف النص باستخدام DOMPurify
  const cleanHtml = (html) => {
    return DOMPurify.sanitize(html);
  };

  // دالة لعرض النص بناءً على الفحص
  const renderText = (text , TextStyle) => {
    if (containsHTML(text)) {
      return (
        <div
          className={`${TextStyle ? TextStyle : "body-2 text-tcolor-5 dark:text-tcolor-2"}`}
          dangerouslySetInnerHTML={{ __html: cleanHtml(text) }}
        />
      );
    } else {
      return (
        <p  className={`${TextStyle ? TextStyle : "body-2 text-tcolor-5 dark:text-tcolor-2"}`}>
          {text}
        </p>
      );
    }
  };
export { truncateText, renderText };    